import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar. ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Cargando datos... ")
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Cargando datos... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabView = _resolveComponent("TabView")!
  const _component_HomeworkDeliveriesModal = _resolveComponent("HomeworkDeliveriesModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TabView, {
      model: _ctx.menuItems,
      activeIndex: _ctx.activeIndex,
      "onUpdate:activeIndex": _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeIndex = $event)),
      class: "rounded-tabmenu menu-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TabPanel, { header: "Estudiante" }, {
          default: _withCtx(() => [
            (_ctx.activeIndex === 0)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: _ctx.asStudent,
                  loading: _ctx.loading
                }, {
                  empty: _withCtx(() => [
                    _hoisted_1
                  ]),
                  loading: _withCtx(() => [
                    _hoisted_2
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Comisión",
                      field: "numberId"
                    }),
                    _createVNode(_component_Column, {
                      header: "Curso",
                      field: "name"
                    }),
                    _createVNode(_component_Column, { header: "Inicio" }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.calendar.start)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Fin" }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.calendar.end)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Clases" }, {
                      body: _withCtx(({data: { classes, courseProgress }}) => [
                        _createTextVNode(_toDisplayString(courseProgress) + "/" + _toDisplayString(classes), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Ausencias" }, {
                      body: _withCtx(({data: { consecutiveAbsences, absences }}) => [
                        _createTextVNode(_toDisplayString(absences) + "/3 (Consec: " + _toDisplayString(consecutiveAbsences) + ") ", 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Entregas" }, {
                      body: _withCtx(({data: { challengesStats: { approved, delivered, onHold } }, data }) => [
                        _withDirectives(_createElementVNode("u", {
                          onClick: () => _ctx.setShowHomeworkModal(data),
                          class: "clickable"
                        }, [
                          _createTextVNode(_toDisplayString(approved) + "/" + _toDisplayString(delivered) + "/" + _toDisplayString(onHold), 1)
                        ], 8, _hoisted_3), [
                          [
                            _directive_tooltip,
                            
                `${approved} - Aprobados <br/> ${delivered} - Entregados <br /> ${onHold} - En espera`
              ,
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_TabPanel, { header: "Staff" }, {
          default: _withCtx(() => [
            (_ctx.activeIndex === 1)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  value: _ctx.asStaff,
                  loading: _ctx.loading
                }, {
                  empty: _withCtx(() => [
                    _hoisted_4
                  ]),
                  loading: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Comisión",
                      field: "numberId"
                    }),
                    _createVNode(_component_Column, {
                      header: "Curso",
                      field: "name"
                    }),
                    _createVNode(_component_Column, { header: "Inicio" }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.calendar.start)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Fin" }, {
                      body: _withCtx(({data}) => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(data.calendar.end)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Rol" }, {
                      body: _withCtx(({ data: { personRole } }) => [
                        _createTextVNode(_toDisplayString(personRole ? _ctx.capitalize(_ctx.t(`api.roles.${personRole}`)) : '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Rating" }, {
                      body: _withCtx(({ data: { rating } }) => [
                        _createTextVNode(_toDisplayString(rating ? _ctx.truncate(rating) : '-'), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, { header: "Estado" }, {
                      body: _withCtx(({ data: { status } }) => [
                        _createTextVNode(_toDisplayString(_ctx.capitalize(_ctx.t(`api.course-status.${status}`))), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "loading"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "activeIndex"]),
    _createVNode(_component_HomeworkDeliveriesModal, {
      courseSummary: _ctx.selectedStudentCourseSummary,
      visible: _ctx.showHomeworkModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showHomeworkModal = $event))
    }, null, 8, ["courseSummary", "visible"])
  ], 64))
}